import { Converter } from '../types/converter';

export const volumeChargeDensityConverter: Converter = {
  id: 'volumeChargeDensity',
  name: 'Volume Charge Density Converter',
  icon: 'Box',
  categories: ['electricity'],
  units: [
    // Base SI unit
    { name: 'Coulomb/cubic meter', symbol: 'C/m³', factor: 1 },
    { name: 'Coulomb/cubic centimeter', symbol: 'C/cm³', factor: 1000000 },
    { name: 'Coulomb/cubic inch', symbol: 'C/in³', factor: 61023.744094732 },
    
    // CGS units
    { name: 'Abcoulomb/cubic meter', symbol: 'abC/m³', factor: 10 },
    { name: 'Abcoulomb/cubic centimeter', symbol: 'abC/cm³', factor: 10000000 },
    { name: 'Abcoulomb/cubic inch', symbol: 'abC/in³', factor: 610237.44094732 }
  ]
};
